import { render, staticRenderFns } from "./company_table.vue?vue&type=template&id=7345cc2a&scoped=true"
import script from "./company_table.vue?vue&type=script&lang=ts"
export * from "./company_table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7345cc2a",
  null
  
)

export default component.exports